import { FeedbackAlert } from '../app/FeedbackAlert.tsx';
import { Page } from '../components/page/Page.tsx';
import { usePageView } from '../support/tracking/usePageView.tsx';
import { MissionList } from './components/MissionList.tsx';
import { IMissionListSection } from './model/MissionsState.ts';

export const MissionListPage = ({ initialAccordionValue }: { initialAccordionValue?: IMissionListSection}) => {
    usePageView('Missions');

    return (
        <Page title="Missions"  >
            <FeedbackAlert />

            <MissionList initialAccordionValue={initialAccordionValue} />

        </Page>
    );
};
